import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface SiteListPayload {
    page: number;
    recherche: string;
    unpaged?: boolean;
    inclureTermines?: boolean;
}

export class SiteSearchDTO implements SiteListPayload {
    page: number;
    recherche: string;
    unpaged?: boolean;
    societeId?: number
    inclureTermines?: boolean;

    constructor(page: number, recherche: string, unpaged?: boolean, inclureTermines?: boolean){
        this.page = page;
        this.recherche = recherche;
        this.unpaged = unpaged;
        this.inclureTermines = inclureTermines;
    }

}

class SiteListService {
    public async getSiteList(params: SiteListPayload): Promise<any> {
        return http.get(Routes.SiteListRoutes.GetList(), {params: { ...params, sort: 'description,asc' }});
    }
    public async getGroupeListBySites(listAdresseId: number[]): Promise<any> {
        return http.get(Routes.SiteListRoutes.GetGroupeBySite(), {params: {adresseSiteId : listAdresseId}});
    }
    public async getSousGroupeListBySites(listAdresseId: number[]): Promise<any> {
        return http.get(Routes.SiteListRoutes.GetSousGroupeBySite(), {params: {adresseSiteId : listAdresseId}});
    }
}

export default new SiteListService();
